import { scroll } from "../base/scroll";

export function stopScroller() {
    scroll.stop();
}

export function startScroller() {
    scroll.start();
}

export const debounce = <T extends unknown[]>(callback: (...args: T) => void, delay: number) => {
    let timeoutTimer: ReturnType<typeof setTimeout>;

    return (...args: T) => {
        clearTimeout(timeoutTimer);

        timeoutTimer = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};
